import { render, staticRenderFns } from "./ProductionCard.vue?vue&type=template&id=3585041d&scoped=true"
import script from "./ProductionCard.vue?vue&type=script&lang=js"
export * from "./ProductionCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3585041d",
  null
  
)

export default component.exports